import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { DatabaseProvider } from './context/DatabaseContext'; // Import the DatabaseProvider
import Terminal from './Terminal';

import Scanner3 from './tools/scanner3/Scanner3';
import JobDisplay from './display/JobDisplay';

export const host_url = "/api";
// Zentrale Adresse des Stormini-Portals. Im Camp-Intranet zeigt
// stormini-portal.de per DNS-Override auf den lokalen Server.
export const portal_url = process.env.REACT_APP_PORTAL_URL || "http://stormini-portal.de";

function App() {

  return (
    <DatabaseProvider> {/* Wrap the application in the DatabaseProvider */}
      <Router>
        <Routes>
          <Route path="/terminal" element={<Terminal />} />
          <Route
            path="/tools/scanner3"
            element={<Scanner3 />}
          />
          <Route path="/jobs" element={<JobDisplay />} />
          <Route path="*" element={<Terminal />} />
        </Routes>
      </Router>
    </DatabaseProvider>
  );
}

export default App;
